import {useEffect, useState} from "react";
import {useSpring} from "framer-motion";

import {Animated} from "../../atoms/Animated";

export const useAnimatedHomepageHeader = (slides: string[]) => {
    const [index, setIndex] = useState(0);

    const opacity = useSpring(0, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(1);

        const timeout = setTimeout(() => {
            opacity.set(0);
            setTimeout(() => {
                setIndex((state) => (state + 1) % slides.length);
                opacity.set(1);
            }, 500);
        }, 6000);

        return () => clearTimeout(timeout);
    }, [index, slides.length, opacity]);

    return <Animated style={{opacity}}>{slides[index]}</Animated>;
};
import {useEffect, useState} from "react";
import {useSpring} from "framer-motion";

import {Animated} from "../../atoms/Animated";

export const useAnimatedHomepageHeader = (slides: string[]) => {
    const [index, setIndex] = useState(0);

    const opacity = useSpring(0, {stiffness: 100, damping: 20});

    useEffect(() => {
        opacity.set(1);

        const timeout = setTimeout(() => {
            opacity.set(0);
            setTimeout(() => {
                setIndex((state) => (state + 1) % slides.length);
                opacity.set(1);
            }, 500);
        }, 6000);

        return () => clearTimeout(timeout);
    }, [index, slides.length, opacity]);

    return <Animated style={{opacity}}>{slides[index]}</Animated>;
};
